__turbopack_context__.v({
  "bannerItem": "JybAXG_bannerItem",
  "bannerWrapper": "JybAXG_bannerWrapper",
  "divider": "JybAXG_divider",
});
